import React from 'react'
import { Link } from 'react-router-dom'

function NavBar() {
  var neo4tourism = "neo4tourism hidden";
  var booking = "booking hidden";

  document.title = "Home";
  if(window.location.pathname.startsWith("/Neo4Tourism")){
    neo4tourism = "neo4tourism show";
    document.title = "Neo4Tourism";
  }
  else if(window.location.pathname.startsWith("/Booking")){
    booking = "booking show";
    document.title = "Booking";
  }
  /* else if(window.location.pathname.startsWith("/SpanningTrees")){
    spanningTrees = "spanningTrees show";
    document.title = "Propagation";
  }*/

    return (
        <div className="sidebar">
          <ul className="firstline">
            <li className="side-button"><Link to="/" onClick={() => {changeBar(1)}}>e-Khonsou</Link></li>
            <li className="side-button"><Link to="/Neo4Tourism" onClick={() => {changeBar(2)}}>Neo4Tourism</Link></li>
            <li className="side-button"><Link to="/Booking" onClick={() => {changeBar(3)}}>Booking</Link></li>

            <li className="side-button"><Link to="/Login/Login" onClick={() => {changeBar(5)}}>Login</Link></li>
          </ul>
          <ul className="secondline">
            <li className={neo4tourism}><Link to="/Neo4Tourism/Region" className="side-button">Regions</Link></li>
            <li className={neo4tourism}><Link to="/Neo4Tourism/Department" className="side-button">Departements</Link></li>
            <li className={neo4tourism}><Link to="/Neo4Tourism/District" className="side-button">Cantons</Link></li>
            <li className={neo4tourism}><Link to="/Neo4Tourism/Stats" className="side-button">Statistiques</Link></li>
            <li className={neo4tourism}><Link to="/Neo4Tourism/Tutorial" className="side-button">Tutoriel</Link></li>
            <li className={booking}><Link to="/Booking/Zones" className="side-button">Zones</Link></li>
            <li className={booking}><Link to="/Booking/Ventilation" className="side-button">Ventilation</Link></li>
            <li className={booking}><Link to="/Booking/Stats" className="side-button">Frequentation</Link></li>
            <li className={booking}><Link to="/Booking/Hebergements" className="side-button">Hebergements</Link></li>
            <li className={booking}><Link to="/Booking/Bench" className="side-button">Benchmark</Link></li>
            <li className={booking}><Link to="/Booking/Tutorial" className="side-button">Tutoriel</Link></li>
          </ul>
        </div>
    )
}
//            <li className="side-button"><Link to="/SpanningTrees" onClick={() => {changeBar(4)}}>SpanningTrees</Link></li>

/*<!--            <li className={spanningTrees}><Link to="/SpanningTrees/Country" className="side-button">Pays</Link></li>
            <li className={spanningTrees}><Link to="/SpanningTrees/Region" className="side-button">Region</Link></li>
            <li className={spanningTrees}><Link to="/SpanningTrees/Department" className="side-button">Departements</Link></li>
            <li className={spanningTrees}><Link to="/SpanningTrees/District" className="side-button">Cantons</Link></li>
            <li className={spanningTrees}><Link to="/SpanningTrees/Statistiques" className="side-button">Statistiques</Link></li>
            <li className={spanningTrees}><Link to="/SpanningTrees/Tutoriel" className="side-button">Tutoriel</Link></li>
*/
//            <h3 className="sidebar-title">Menu</h3>

export function changeBar(menu){
  if (menu === 2)
    showHide('neo4tourism', 'inline-block');
  else
    showHide('neo4tourism', 'none');
  if (menu === 3)
    showHide('booking', 'inline-block');
  else
    showHide('booking', 'none');
  /*if (menu === 4)
    showHide('spanningTrees', 'inline-block');
  else
    showHide('spanningTrees', 'none');*/
  if (menu === 5)
    showHide('login', 'inline-block');
  else
    showHide('login', 'none');
}
export function showHide (myClass, status){
  Array.from(document.getElementsByClassName(myClass)).forEach((item) => {item.style.display = status;});

}

export default NavBar;
